module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "charts"
    }
  }, [_vm._v("Charts and Figures")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "6603_DOTS.jpg",
      "src": "Images/6603_DOTS.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#figure-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conversion: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("A Spiritual Process")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(chap. 2)")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#chart-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Contrasts in the Gospel Content "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(chap. 3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#figure-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contrasting Views of God "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(chap. 4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#chsv",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Come Home: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Simplified Version")]), _vm._v(" (for sharing) "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(chap. 4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5#figure-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Method of Salvation "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(chap. 5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap10#figure-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Ways to Converse About Christ "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(chap. 10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap10#chart-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turning Conversations to Christ "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(chap. 10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap10#figure-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conversational Evangelism "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(chap. 10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap10#chart-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Goal in Witnessing Affects the Methods "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(chap. 10)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b5b1426","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chartsandfigures.vue
// module id = 72
// module chunks = 0